const columnName = [
  {
    key: "OrderNumber",
    Level: "Order Number",
    Selected: true,
    Disabled: true,
  },
  {
    key: "OrderStatus",
    Level: "Order Status",
    Selected: true,
    Disabled: false,
  },

  {
    key: "OrderDate",
    Level: "Order Date",
    Selected: true,
    Disabled: false,
  },
  {
    key: "OrderContainerRates",
    Level: "Rates",
    Selected: true,
    Disabled: false,
  },
  {
    key: "ContainerCount",
    Level: "Total Container Count",
    Selected: true,
    Disabled: true,
  },
  {
    key: "TotalCost",
    Level: "Total Cost",
    Selected: true,
    Disabled: true,
  },
  {
    key: "BuyerName",
    Level: "Buyer",
    Selected: true,
    Disabled: true,
  },
  {
    key: "BuyerCode",
    Level: "Buyer Code",
    Selected: false,
    Disabled: false,
  },
  {
    key: "SupplierName",
    Level: "Supplier",
    Selected: true,
    Disabled: true,
  },

  {
    key: "SupplierCode",
    Level: "Supplier Code",
    Selected: false,
    Disabled: false,
  },
  {
    key: "SendingAgentName",
    Level: "Sending Agent",
    Selected: true,
    Disabled: false,
  },
  {
    key: "SendingAgentCode",
    Level: "Sending Agent Code",
    Selected: false,
    Disabled: false,
  },
  {
    key: "ReceivingAgentName",
    Level: "Receiving Agent",
    Selected: true,
    Disabled: false,
  },
  {
    key: "ReceivingAgentCode",
    Level: "Receiving Agent Code",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderTransportMode",
    Level: "Transport Mode",
    Selected: true,
    Disabled: false,
  },
  {
    key: "SplitNumber",
    Level: "Split Number",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderCurrency",
    Level: "Currency",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderIncoterm",
    Level: "Incoterm",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderContainerMode",
    Level: "Container Mode",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderContainerCount",
    Level: "Container Count",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderContainerNameandType",
    Level: "Container Number",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderTotalTEU",
    Level: "TotalTEU ",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderWeight",
    Level: "Weight",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderWeightUnit",
    Level: "Weight Unit",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderVolume",
    Level: "Volume",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderVolumeUnit",
    Level: "Volume Unit",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderChargeableWeight",
    Level: "Chargeable Weight",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderChargeableWeightUnit",
    Level: "Chargeable WeightUnit",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderReqStoreDate",
    Level: "ReqStoreDate",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderServiceLevelCode",
    Level: "Service Level",
    Selected: false,
    Disabled: false,
  },
  {
    key: "ShipmentNumber",
    Level: "Shipment Number",
    Selected: false,
    Disabled: false,
  },
  {
    key: "InvoiceNumber",
    Level: "Invoice Number",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OriginCountry",
    Level: "Origin Country",
    Selected: false,
    Disabled: false,
  },
  {
    key: "DestinationCountry",
    Level: "Destination Country",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderSpecialDescription",
    Level: "Special Instruction",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderOriginPortCode",
    Level: "Load Port",
    Selected: true,
    Disabled: false,
  },
  {
    key: "OrderOriginPortName",
    Level: " Load Port Name",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderDestinationPortCode",
    Level: "Discharge Port",
    Selected: true,
    Disabled: false,
  },
  {
    key: "OrderFinalDesPortCode",
    Level: "Final Destination",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderFinalDesPortName",
    Level: "Final Destination Name",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderCarrierCode",
    Level: "Carrier",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderCarrierName",
    Level: "Carrier Name",
    Selected: false,
    Disabled: false,
  },
  {
    key: "Order Vessal",
    Level: "Vessal",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderVoyage",
    Level: "Voyage",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderETD",
    Level: "ETD",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderETA",
    Level: "ETA",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderCutoffDate",
    Level: "CutoffDate",
    Selected: false,
    Disabled: false,
  },
  {
    key: "OrderMblNumber",
    Level: "Mbl Number",
    Selected: false,
    Disabled: false,
  },
];

export default columnName;
